import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { PureComponent } from 'react';
import { Modal, ListGroup, Button, Container, Nav} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBellSlash, faXmark } from '@fortawesome/free-solid-svg-icons';

import { IconButton } from '../component/IconButton';

const DEFAULT_MSG: Message[] = [
  {
    title: 'Testing version',
    content:
      'Attention, this is the testing version. Please note that the tokens you trade are all test tokens and have no actual value. The functions you currently use will exist in the future official versions.'
  },
  {
    title: 'Faucet',
    content:
      <>Please collect the test tokens through <Nav.Link href="#/faucet"className="d-inline">the faucet</Nav.Link> and start testing. These tokens have no actual value, so please get the tokens you need. There is no need to get too many tokens.Nav.Link</>
  }
];

interface Message {
  title: string;
  content: any;
}

@observer
export default class Notification extends PureComponent {
  @observable
  messages: Message[] = DEFAULT_MSG;

  @observable
  currentMessage?: Message;

  handleClose = () => (this.currentMessage = undefined);

  renderList = (message: Message) => (
    <ListGroup.Item
      key={message.title}
      className="position-relative bg-dark text-secondary"
    >
      <h6 style={{fontSize:'0.875rem'}}>{message.title}</h6>
      <p className="text-truncate pb-2">{message.content}</p>
      <Button
        variant="link"
        className="text-white text-decoration-none position-absolute bottom-0 end-0"
        onClick={() => (this.currentMessage = message)}
      >
        Detail
      </Button>
    </ListGroup.Item>
  );

  render() {
    const { messages, currentMessage } = this;

    return (
      <>
        <ListGroup variant="flush">
          {messages[0] ? (
            messages.map(this.renderList)
          ) : (
            <Container>
              <FontAwesomeIcon icon={faBellSlash} />
            </Container>
          )}
        </ListGroup>

        <Modal
          className="text-muted"
          show={!!currentMessage}
          centered
          onHide={this.handleClose}
        >
          <Modal.Header className="bg-info text-white p-0 py-2">
            <Modal.Title as="h5" style={{ fontSize: '1.125rem' }}>{currentMessage?.title}</Modal.Title>

            <IconButton icon={faXmark} onClick={this.handleClose} />
          </Modal.Header>
          <Modal.Body style={{fontSize:'0.875rem'}} className="bg-info text-secondary pb-4">
           
              {currentMessage?.content}
           
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
